import {
  Invoice as ApiInvoice,
  fetchInvoice as apiFetchInvoice,
} from 'api/invoices';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle, no-restricted-imports
import { Dispatch, GetState } from '..';
import { setError } from './error';

// Types

export type Invoice = ApiInvoice & {
  isFetching: boolean;
};
export type State = {
  byId: Record<
    string,
    Invoice & {
      isFetching: boolean;
    }
  >;
};

type FetchInvoiceRequestAction = {
  type: 'FETCH_INVOICE_REQUEST';
  invoiceId: string;
};
type FetchInvoiceSuccessAction = {
  type: 'FETCH_INVOICE_SUCCESS';
  invoice: ApiInvoice;
};
export type Action = FetchInvoiceRequestAction | FetchInvoiceSuccessAction;

// Reducer

export function invoicesReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = {
    byId: {},
  },
  action: Action
) {
  switch (action.type) {
    case 'FETCH_INVOICE_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.invoiceId]: {
            ...state.byId[action.invoiceId],
            id: action.invoiceId,
            isFetching: true,
          },
        },
      };

    case 'FETCH_INVOICE_SUCCESS':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.invoice.id]: { ...action.invoice, isFetching: false },
        },
      };

    default:
      return state;
  }
}

// Actions

const fetchInvoiceRequest = (invoiceId: string): FetchInvoiceRequestAction => ({
  type: 'FETCH_INVOICE_REQUEST',
  invoiceId,
});

const fetchInvoiceSuccess = (
  invoice: ApiInvoice
): FetchInvoiceSuccessAction => ({
  type: 'FETCH_INVOICE_SUCCESS',
  invoice,
});

export const fetchInvoice =
  (invoiceId: string) => (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const invoice = state.invoices.byId[invoiceId];

    if (!invoice) {
      dispatch(fetchInvoiceRequest(invoiceId));
      apiFetchInvoice(invoiceId)
        .then((fetchedInvoice) => {
          dispatch(fetchInvoiceSuccess(fetchedInvoice));
        })
        .catch((e) => {
          dispatch(setError(e));
        });
    }
  };
